import React, { FC, PropsWithChildren } from 'react';
import { ModalProps } from '@models/interfaces';
import { Modal } from '@shared/modules';

import './styles.scss';

export const DeleteProjectModal: FC<ModalProps> = (
  props: PropsWithChildren<ModalProps>,
) => (
  <Modal
    title="Delete Project"
    okText="Delete"
    className="prov-delete-project-modal"
    {...props}
  >
    Are you sure you want to delete this Project?
  </Modal>
);
